import { Col, Form, Row, Spinner } from 'react-bootstrap'
import { emptyGuid } from '../../../utils/emptyGuid'
import { emptyDate, isEmptyDate } from '../../../utils/emptyDate'
import React, { useCallback, useEffect, useState } from 'react'
import apiClient from '../../../utils/api/apiClient'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import CustomDatePicker from '../../Forms/CustomDatePicker'
import { getIsoDate } from '../../../utils/getIsoDate'
import { useTranslation } from 'react-i18next'
import { StyledValidationMessage } from '../../Employees/Form/formHelper'
import ArraySelect from '../../Select/ArraySelect'
import MandatoryField from '../../MandatoryField/MandatoryField'
import ArticleSelect from '../Form/ArticleSelect'
import WarehousesSelect from '../Form/WarehousesSelect'
import { makeCall } from '../../../utils/api/makeCall'

const DispoListStatistics = ({ formData, setFormData, formErrors }) => {
    const { t } = useTranslation()
    const [dateFrom, setDateFrom] = useState(null)
    const [dateTo, setDateTo] = useState(null)
    const [groupSelection, setGroupSelection] = useState(false)
    const [sortByNumber, setSortByNumber] = useState(false)
    const [includeAllArticlesOfMandator, setIncludeAllArticlesOfMandator] = useState(false)
    const [includeShipmentRequestStatistics, setIncludeShipmentRequestStatistics] = useState(true)
    const [includeSheetDispoArticleOverview, setIncludeSheetDispoArticleOverview] = useState(false)
    const [includeRequestedIngredientStatistic, setIncludeRequestedIngredientStatistic] = useState(false)

    const [procurementGroups, setProcurementGroups] = useState([])
    const [errorStates, setErrorStates] = useState({})
    const [loadingStates, setLoadingStates] = useState({})
    useEffect(() => {
        setFormData(prev => {
            if (dateFrom) {
                return { ...prev, startDate: getIsoDate(dateFrom, false) }
            }
            delete prev.startDate
            return prev
        })
    }, [setFormData, dateFrom])
    useEffect(() => {
        setFormData(prev => {
            if (dateFrom) {
                let isoDate = getIsoDate(dateTo, true)
                return { ...prev, endDate: isEmptyDate(isoDate) ? emptyDate : isoDate }
            }
            delete prev.endDate
            return prev
        })
    }, [setFormData, dateTo, dateFrom])
    const handleChangeDate = useCallback(setDate => date => {
        setDate(date)
    }, [])
    const updateCheckboxAndRadioProperty = (event, name) => {
        switch (name) {
            case 'singleSelection':
                setGroupSelection(false)
                setFormData(prev => ({
                ...prev,
                warehouse_ProcurementGroupID: emptyGuid 
                }))
                break
            case 'groupSelection':
                setGroupSelection(true)
                break
            case 'sortByNumber':
                setSortByNumber(true)
                setFormData(prev => ({
                ...prev,
                sortBy_ArtNr: event.target.checked,
                sortBy_ArtName: !event.target.checked
                }))
                break
            case 'sortByName':
                setSortByNumber(false)
                setFormData(prev => ({
                ...prev,
                sortBy_ArtNr: !event.target.checked,
                sortBy_ArtName: event.target.checked
                }))
                break
            case 'includeAllArticlesOfMandator':
                setIncludeAllArticlesOfMandator(event.target.checked)
                setFormData(prev => ({
                ...prev,
                includeAllArticlesOfMandator: event.target.checked
                }))
                break
            case 'includeShipmentRequestStatistics':
                setIncludeShipmentRequestStatistics(event.target.checked)
                setFormData(prev => ({
                ...prev,
                includeShipmentRequestStatistics: event.target.checked
                }))
                break
            case 'includeSheetDispoArticleOverview':
                setIncludeSheetDispoArticleOverview(event.target.checked)
                setFormData(prev => ({
                ...prev,
                includeSheetDispoArticleOverview: event.target.checked
                }))
                break
            case 'includeRequestedIngredientStatistic':
                setIncludeRequestedIngredientStatistic(event.target.checked)
                setFormData(prev => ({
                ...prev,
                includeRequestedIngredientStatistic: event.target.checked
                }))
                break
            default:
        }
      }
    const loadProcurementGroups = useCallback(async () => {
        makeCall('loadProcurementGroups', async () => {
          let loadedProcurementGroups = await apiClient.getJson(APIEndpoints.procurementGroups)
          setProcurementGroups(loadedProcurementGroups)
        }, setErrorStates, setLoadingStates)
    
      }, [])
    useEffect(() => {
        loadProcurementGroups()
    }, [loadProcurementGroups])
    useEffect(() => {
        if(!includeShipmentRequestStatistics && !includeSheetDispoArticleOverview && !includeRequestedIngredientStatistic)
        {
            setIncludeShipmentRequestStatistics(true)
            setFormData(prev => ({
                ...prev,
                includeShipmentRequestStatistics: true
                }))
        }
    }, [setFormData, setIncludeShipmentRequestStatistics, includeShipmentRequestStatistics, includeSheetDispoArticleOverview, includeRequestedIngredientStatistic])

    if(errorStates.loadProcurementGroups)console.log('loadProcurementGroups errorStates:', errorStates.loadProcurementGroups)
  return (
    <div>
        <>
            <Row>
                <Col>
                    <Form.Group className="mb-3">
                        <Form.Label>{`${t('from')}${'*'}`}</Form.Label>
                        <CustomDatePicker
                            dateFormat="dd.MM.yyyy"
                            placeholderText={t('date')}
                            onChange={handleChangeDate(setDateFrom)}
                            showYearDropdown
                            selected={dateFrom}
                            isInvalid={formErrors && formErrors.startDate}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-3">
                        <Form.Label>{`${t('to')}${'*'}`}</Form.Label>
                        <CustomDatePicker
                            dateFormat="dd.MM.yyyy"
                            placeholderText={t('date')}
                            onChange={handleChangeDate(setDateTo)}
                            showYearDropdown
                            selected={dateTo}
                            isInvalid={formErrors && formErrors.endDate}
                        />
                    </Form.Group>
                </Col>
            </Row>
            {formErrors && formErrors.startDate && <StyledValidationMessage>{formErrors.startDate}</StyledValidationMessage>}
            {formErrors && formErrors.endDate && <StyledValidationMessage>{formErrors.endDate}</StyledValidationMessage>}
        </>
        <Form.Group>
        <Form.Label className="d-block">{`${t('reportConfig:warehouseSelection')}${'*'}`}</Form.Label>
        <Form.Check
            inline
            type="radio"
            id="singleSelection"
            name="warehouseSelection"
            label={t('reportConfig:singleSelection')}
            checked={!groupSelection}
            onChange={(e) => updateCheckboxAndRadioProperty(e, 'singleSelection')}
        />
        <Form.Check
            inline
            type="radio"
            id="groupSelection"
            name="warehouseSelection"
            label={t('reportConfig:groupSelection')}
            checked={groupSelection}
            onChange={(e) => updateCheckboxAndRadioProperty(e, 'groupSelection')}
        />
         </Form.Group>
        {!groupSelection && <WarehousesSelect
            name="includedWarehouseIDs"
            value={formData.includedWarehouseIDs}
            setFormData={setFormData}
        />
        }
        {loadingStates.loadProcurementGroups
          ? <div className="d-flex align-items-center justify-content-center"><Spinner animation='border' variant='primary' /></div>
          : <>
             {groupSelection &&
                <Form.Group>
                <ArraySelect
                      value={formData.warehouse_ProcurementGroupID}
                      defaultOption={{ value: emptyGuid, name: t('pleaseSelect') }}
                      defaultOptionIsSelectable
                      options={procurementGroups}
                      noAutoSelect
                      onChange={e => setFormData(prev => ({
                        ...prev,
                        warehouse_ProcurementGroupID: e.target.value
                      }))}
                      disabled={!groupSelection}
                      returnEvent
                    />
                </Form.Group>
            }
          </>
        }
        <Form.Group className="mb-3">
        <Form.Label className="d-block">{`${t('reportConfig:articleSelection')}${'*'}`}</Form.Label>
        <ArticleSelect
            name="articleIDs"
            value={formData.articleIDs}
            setFormData={setFormData}
            disabled={includeAllArticlesOfMandator}
        />
        <Form.Check
            id="includeAllArticlesOfMandator"
            label={t('reportConfig:dispolistIncludeAllArticlesOfMandator')}
            type="checkbox"
            name="includeAllArticlesOfMandator"
            onChange={(e) => updateCheckboxAndRadioProperty(e, 'includeAllArticlesOfMandator')}
            checked={includeAllArticlesOfMandator}
        />
        </Form.Group>
        <Form.Group className="mb-3">
        <Form.Label>{t('reportConfig:options')}</Form.Label>
        <Form.Check
            id="includeShipmentRequestStatistics"
            label={t('reportConfig:dispolistIncludeShipmentRequestStatistics')}
            type="checkbox"
            name="includeShipmentRequestStatistics"
            onChange={(e) => updateCheckboxAndRadioProperty(e, 'includeShipmentRequestStatistics')}
            checked={includeShipmentRequestStatistics}
            isInvalid={formErrors && formErrors.includeShipmentRequestStatistics}
        />
        <Form.Check
            id="includeSheetDispoArticleOverview"
            label={t('reportConfig:dispolistIncludeSheetDispoArticleOverview')}
            type="checkbox"
            name="includeSheetDispoArticleOverview"
            onChange={(e) => updateCheckboxAndRadioProperty(e, 'includeSheetDispoArticleOverview')}
            checked={includeSheetDispoArticleOverview}
            isInvalid={formErrors && formErrors.includeSheetDispoArticleOverview}
        />
        <Form.Check
            id="includeRequestedIngredientStatistic"
            label={t('reportConfig:dispolistIncludeRequestedIngredientStatistic')}
            type="checkbox"
            name="includeRequestedIngredientStatistic"
            onChange={(e) => updateCheckboxAndRadioProperty(e, 'includeRequestedIngredientStatistic')}
            checked={includeRequestedIngredientStatistic}
            isInvalid={formErrors && formErrors.includeRequestedIngredientStatistic}
        />
        <Form.Control.Feedback type="invalid">
            {formErrors && formErrors.includeShipmentRequestStatistics}
        </Form.Control.Feedback>
        </Form.Group>
        <Form.Group>
        <Form.Label>{t('reportConfig:sorting')}</Form.Label>
        <Form.Check
            type="radio"
            id="sortByNumber"
            name="sorting"
            label={t('reportConfig:sortByNumber')}
            checked={sortByNumber}
            onChange={(e) => updateCheckboxAndRadioProperty(e, 'sortByNumber')}
        />
        <Form.Check
            type="radio"
            id="sortByName"
            name="sorting"
            label={t('reportConfig:sortByName')}
            checked={!sortByNumber}
            onChange={(e) => updateCheckboxAndRadioProperty(e, 'sortByName')}
        />
        </Form.Group>
        <Form.Group className="mb-3">
            <Form.Label>{t(`reportConfig:emailAddress`)}</Form.Label>
            <Form.Control 
            name="emailAddress" 
            onChange={e => setFormData(prev => ({
                ...prev,
                emailAddress: e.target.value
              }))}
            value={formData.emailAddress || ''} 
            isInvalid={formErrors && formErrors.emailAddress} 
            autoComplete="email" />
            <Form.Control.Feedback type="invalid">
                {formErrors && formErrors.emailAddress}
            </Form.Control.Feedback>
        </Form.Group>
        <MandatoryField />
    </div>
  )
}
export default DispoListStatistics